import React from 'react'
import { ButtonIconSeeker, AutocompleteAjaxSeeker, IconSeeker } from '@ui-seeker/core'
import { copyToClipboard } from '@ui-seeker/utils'
import { Box, Typography } from '@mui/material'

import { useToast } from '@hooks'
import { BI_ROUTES, BACKEND_APIS } from '@constants'
import { BIFormData, BIOpenUrlModal, BIUrlId } from 'Pages/BusinessLogistics/BI/Page/@signals'
import useDeleteUrl from 'Pages/BusinessLogistics/BI/Page/@hooks/useDeleteUrl'
import { dsColorNew } from "@palette"
import { headerIconButtonSx } from "@components"
import { encodeSpParam } from "@utils/spParam"


export default function BIPageWrapperActions() {
	const { showToast } = useToast()
	const { handleDeleteUrl } = useDeleteUrl()


	const onAjaxCommon = options => options.map(option => ({
		label: `${option.label}`,
		path: option.path,
		value: `${option.value}`,
	}))


	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		<ButtonIconSeeker
			icon="link"
			iconWeight="regular"
			tooltip="Copy filters link to clipboard"
			sx={headerIconButtonSx}
			onClick={() => {
				try {
					copyToClipboard(`rentacar.dataseekers.com${BI_ROUTES.PATH}?sp=${encodeSpParam(BIFormData.value)}`)
					showToast.success('Url copied to clipboard')
				} catch {
					showToast.error('Could not copy to clipboard')
				}
			}}
		/>

		<ButtonIconSeeker
			icon="floppy-disk"
			iconWeight="regular"
			tooltip="Save filters link"
			sx={headerIconButtonSx}
			onClick={() => BIOpenUrlModal.value = `${BI_ROUTES.PATH}?sp=${encodeSpParam(BIFormData.value)}`}/>
		<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
			sx={{ width: 180 }}
			inputProps={{ startAdornment: <IconSeeker icon="bookmark" iconWeight="regular" sx={{ fontSize: 13, color: dsColorNew.textMuted, ml: 0.5, mr: 0.25 }}/> }}
			value={BIUrlId.value}
			urlAjax={`${BACKEND_APIS.DASHBOARD}/get-filters`}
			onAjax={onAjaxCommon}
			getOptionLabel={({ label }) => label || ''}
			formatOptionLabel={option => <LabelComponent {...option} handleDelete={handleDeleteUrl} />}
			onChange={(e) => {
				BIUrlId.value = e.target.value
			}}
			filters={{
				urlId: BIUrlId.value,
			}}
		/>
	</Box>
}


function LabelComponent({label , value, path, handleDelete}) {

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
			<Typography
				sx={{ width: '100%' }}
				onClick={() => {
					BIUrlId.value = value
					window.open(path, '_blank')
				}}
			>{label}
			</Typography>
			<ButtonIconSeeker
				icon='trash-can'
				iconWeight="regular"
				sx={{ fontSize: 13, color: dsColorNew.textMuted, '& *': { color: 'inherit' }, '&:hover': { color: dsColorNew.dangerRed, backgroundColor: dsColorNew.dangerBg } }}
				tooltip='Delete this saved filter'
				onClick={() => {
					handleDelete(value, label)
				}}
			/>
	</Box>
}